import proj4 from 'proj4';

export class Point {
  public coordinates: [number, number];
  public type: 'Point' = 'Point';
  private srid: string;

  constructor(coordinates: [number, number], srid: string = 'EPSG:4326') {
    this.coordinates = [...coordinates];
    this.srid = srid;
  }

  get x(): number {
    return this.coordinates[0];
  }

  get y(): number {
    return this.coordinates[1];
  }

  getCoordinates(): [number, number] {
    return [...this.coordinates];
  }

  setCoordinates(coords: [number, number]): void {
    this.coordinates = [...coords];
  }

  clone(): Point {
    return new Point([...this.coordinates], this.srid);
  }

  transform(fromProj: string, toProj: string): Point {
    const result = proj4(fromProj, toProj, [...this.coordinates]) as [number, number];
    return new Point(result, toProj);
  }

  distanceTo(other: Point): number {
    const dx = this.coordinates[0] - other.coordinates[0];
    const dy = this.coordinates[1] - other.coordinates[1];
    return Math.sqrt(dx * dx + dy * dy);
  }

  equals(other: Point): boolean {
    return (
      this.coordinates[0] === other.coordinates[0] &&
      this.coordinates[1] === other.coordinates[1]
    );
  }

  toGeoJSON(): GeoJSON.Point {
    return {
      type: 'Point',
      coordinates: [...this.coordinates],
    };
  }
}
